export default function Polygon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="admin-page__balloon-polygon"
      width="59"
      height="65"
      fill="none"
      viewBox="0 0 59 65"
    >
      <path fill="url(#paint0_linear_14427_86818)" d="M58.025 64.204L.543 16.006 20.363.49l37.662 63.714z" />
      <defs>
        <linearGradient
          id="paint0_linear_14427_86818"
          x1="58.028"
          x2="20.814"
          y1="64.203"
          y2="6.156"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#3E3E3E" stopOpacity="0.56" />
          <stop offset="1" stopColor="#D9D9D9" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}
